import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api';
import Modal from '../components/Modal';
// heuteIso() liefert den hiesigen Kalendertag. toISOString() wuerde zwischen
// Mitternacht und 02:00 Uhr den Vortag speichern (UTC-Verschiebung).
import { heuteIso } from '../components/ZeitraumWahl';
import { hinweis } from '../components/Hinweise';

const KURS_INFO = {
  pirat:        { label: 'Pirat',        farbe: '#880e4f', bg: '#fce4ec', emoji: '🏴‍☠️', naechster: 'seepferdchen' },
  seepferdchen: { label: 'Seepferdchen', farbe: '#0d47a1', bg: '#e3f2fd', emoji: '🐴',  naechster: 'trixi' },
  trixi:        { label: 'Trixi',        farbe: '#1b5e20', bg: '#e8f5e9', emoji: '🌟',  naechster: 'bronze' },
  bronze:       { label: 'Bronze',       farbe: '#e65100', bg: '#fff3e0', emoji: '🥉',  naechster: 'silber' },
  silber:       { label: 'Silber',       farbe: '#424242', bg: '#f5f5f5', emoji: '🥈',  naechster: 'gold' },
  gold:         { label: 'Gold',         farbe: '#f57f17', bg: '#fffde7', emoji: '🥇',  naechster: 'hai' },
  hai:          { label: 'Hai',          farbe: '#1a237e', bg: '#e8eaf6', emoji: '🦈',  naechster: 'la_silber' },
  la_silber:    { label: 'LA Silber',    farbe: '#37474f', bg: '#eceff1', emoji: '🦈',  naechster: 'la_gold' },
  la_gold:      { label: 'LA Gold',      farbe: '#e65100', bg: '#fff8e1', emoji: '🦈',  naechster: null },
};

function calcAlter(geb) {
  if (!geb) return '–';
  return Math.floor((Date.now() - new Date(geb).getTime()) / (365.25 * 24 * 3600 * 1000)) + ' J.';
}
function fmtDate(d) { return d ? new Date(d).toLocaleDateString('de-DE') : '–'; }

// Suche ohne Rücksicht auf Groß-/Kleinschreibung und Akzente („gonzalez" findet „González")
const suchtext = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export default function GruppenDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [gruppe, setGruppe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Warteliste-Modal
  // Termine
  const [terminWochentag, setTerminWochentag] = useState('1');
  const [terminVon, setTerminVon]             = useState('16:00');
  const [terminBis, setTerminBis]             = useState('17:00');
  const [terminSaving, setTerminSaving]       = useState(false);

  // Prüfungsfortschritt
  const [fortschritt, setFortschritt] = useState(null);
  const [fortschrittLoading, setFortschrittLoading] = useState(false);
  const [fortschrittOpen, setFortschrittOpen] = useState(false);

  const loadFortschritt = async () => {
    setFortschrittLoading(true);
    try {
      const r = await api.get(`/api/admin/gruppen/${id}/fortschritt`);
      setFortschritt(r.data);
    } catch { setFortschritt(null); }
    finally { setFortschrittLoading(false); }
  };

  const toggleFortschritt = () => {
    if (!fortschrittOpen && !fortschritt) loadFortschritt();
    setFortschrittOpen(v => !v);
  };

  const WOCHENTAGE = ['Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag','Sonntag'];

  const handleTerminAdd = async () => {
    setTerminSaving(true);
    try {
      await api.post(`/api/admin/gruppen/${id}/termine`, {
        wochentag: parseInt(terminWochentag),
        uhrzeit_von: terminVon,
        uhrzeit_bis: terminBis || null,
      });
      await load();
    } catch (err) { hinweis.fehler(err.response?.data?.error || 'Fehler'); }
    finally { setTerminSaving(false); }
  };

  const handleTerminDelete = async (terminId) => {
    if (!window.confirm('Termin wirklich löschen?')) return;
    try {
      await api.delete(`/api/admin/gruppen/${id}/termine/${terminId}`);
      await load();
    } catch (err) { hinweis.fehler(err.response?.data?.error || 'Fehler'); }
  };

  const [wlModal, setWlModal] = useState(false);
  const [warteliste, setWarteliste] = useState([]);
  const [wlLoading, setWlLoading] = useState(false);
  const [aufnahmedatum, setAufnahmedatum] = useState(heuteIso());
  const [aufnehmen, setAufnehmen] = useState(null); // ausgewählter WL-Eintrag
  const [aufnehmenSaving, setAufnehmenSaving] = useState(false);
  const [wlSuche, setWlSuche] = useState('');

  // Abschluss-Modal
  const [abschlussModal, setAbschlussModal] = useState(null); // { schwimmer_id, vorname, nachname }
  const [abschlussAktion, setAbschlussAktion] = useState('wechseln'); // 'wechseln' | 'austritt'
  const [naechsteGruppen, setNaechsteGruppen] = useState([]);
  const [naechsteGruppeId, setNaechsteGruppeId] = useState('');
  const [abzeichenDatum, setAbzeichenDatum] = useState(heuteIso());
  const [abschlussBemerkung, setAbschlussBemerkung] = useState('');
  const [abschlussSaving, setAbschlussSaving] = useState(false);

  const [icsLoading, setIcsLoading] = useState(false);

  const handleIcsExport = async () => {
    setIcsLoading(true);
    try {
      const r = await api.get(`/api/admin/gruppen/${id}/termine.ics`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data], { type: 'text/calendar' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = `termine_${gruppe.name}.ics`.replace(/[^a-zA-Z0-9_.-]/g, '_');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      hinweis.fehler('Fehler beim Erstellen des Kalender-Exports');
    } finally {
      setIcsLoading(false);
    }
  };

  const load = useCallback(async () => {
    try {
      const r = await api.get(`/api/admin/gruppen/${id}`);
      setGruppe(r.data);
    } catch {
      setError('Gruppe konnte nicht geladen werden');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => { load(); }, [load]);

  // Warteliste für diese Stufe laden
  const openWlModal = async () => {
    setWlModal(true);
    setAufnehmen(null);
    setWlSuche('');
    setWlLoading(true);
    try {
      const r = await api.get('/api/admin/warteliste', {
        params: { abzeichen: gruppe.kurs_typ },
      });
      setWarteliste((r.data.data || []).filter(w => !['abgelehnt', 'storniert'].includes(w.status)));
    } catch { setWarteliste([]); }
    finally { setWlLoading(false); }
  };

  // Volltextsuche über Kind, Kontakt und E-Mail; jedes Wort muss vorkommen, Reihenfolge egal.
  // Die Liste kommt für eine Stufe vollständig (ohne Seiten), es wird also wirklich alles durchsucht.
  const wlWoerter = suchtext(wlSuche).split(/\s+/).filter(Boolean);
  const wlTreffer = wlWoerter.length === 0 ? warteliste : warteliste.filter(w => {
    const heuhaufen = suchtext(
      `${w.schwimmer_vorname} ${w.schwimmer_nachname} ${w.kontakt_vorname} ${w.kontakt_nachname} ${w.kontakt_email}`
    );
    return wlWoerter.every(wort => heuhaufen.includes(wort));
  });
  const wlAuswahlVersteckt = aufnehmen && !wlTreffer.some(w => w.id === aufnehmen.id);

  const handleAufnehmen = async () => {
    if (!aufnehmen) return;
    setAufnehmenSaving(true);
    const senden = (bestaetigt) => api.post(`/api/admin/gruppen/${id}/aufnehmen`, {
      warteliste_id: aufnehmen.id,
      eingetreten_am: aufnahmedatum,
      ...bestaetigt,
    });
    try {
      try {
        await senden({});
      } catch (err) {
        // Fehlender Aufnahmeantrag und volle Gruppe kommen in einer Rückfrage,
        // damit nicht zwei Dialoge hintereinander erscheinen.
        const d = err.response?.data;
        if (err.response?.status !== 409 || !(d?.aufnahmeantrag_fehlt || d?.gruppe_voll)) throw err;
        const zusatz = [];
        if (d.aufnahmeantrag_fehlt) {
          zusatz.push('Der Antrag muss spätestens nach 2 besuchten Trainings vorliegen – auf Papier über den ' +
            'Trainer oder per E-Mail an den Schwimmadmin. Danach erscheint in der Trainer-App ein deutlicher Hinweis.');
        }
        if (d.gruppe_voll) {
          zusatz.push('Die Gruppe wird damit überbucht. Bitte vorher prüfen, ob Platz im Becken und genug Betreuung da ist.');
        }
        const ok = window.confirm(
          `${d.error}\n\n${aufnehmen.schwimmer_vorname} ${aufnehmen.schwimmer_nachname} trotzdem aufnehmen?\n\n${zusatz.join('\n\n')}`
        );
        if (!ok) return;
        await senden({ vorlaeufig: d.aufnahmeantrag_fehlt || undefined, ueberbuchen: d.gruppe_voll || undefined });
      }
      setWlModal(false);
      await load();
    } catch (err) {
      hinweis.fehler(err.response?.data?.error || 'Fehler bei der Aufnahme');
    } finally { setAufnehmenSaving(false); }
  };

  // Abschluss-Modal öffnen
  const openAbschluss = async (mitglied) => {
    const naechsterTyp = KURS_INFO[gruppe.kurs_typ]?.naechster;
    setAbschlussModal({ schwimmer_id: mitglied.schwimmer_id, vorname: mitglied.vorname, nachname: mitglied.nachname });
    setAbschlussAktion('wechseln');
    setNaechsteGruppeId('');
    setAbzeichenDatum(heuteIso());
    setAbschlussBemerkung('');
    if (naechsterTyp) {
      const r = await api.get('/api/admin/gruppen/auswahl', { params: { kurs_typ: naechsterTyp } });
      setNaechsteGruppen(r.data);
    } else {
      setNaechsteGruppen([]);
      setAbschlussAktion('austritt');
    }
  };

  const handleAbschluss = async () => {
    setAbschlussSaving(true);
    const senden = (ueberbuchen) => api.post('/api/admin/schwimmer/abschluss', {
      schwimmer_id: abschlussModal.schwimmer_id,
      aktion: abschlussAktion,
      naechste_gruppe_id: abschlussAktion === 'wechseln' ? parseInt(naechsteGruppeId) : undefined,
      abzeichen_datum: abzeichenDatum,
      bemerkung: abschlussBemerkung,
      ueberbuchen,
    });
    try {
      try {
        await senden(false);
      } catch (err) {
        // Volle Zielgruppe: Wechsel nur nach ausdrücklicher Bestätigung
        if (err.response?.status !== 409 || !err.response.data?.gruppe_voll) throw err;
        const ok = window.confirm(
          `${err.response.data.error}\n\n${abschlussModal.vorname} ${abschlussModal.nachname} trotzdem dorthin wechseln?\n\n` +
          'Die Gruppe wird damit überbucht.'
        );
        if (!ok) return;
        await senden(true);
      }
      setAbschlussModal(null);
      await load();
    } catch (err) {
      hinweis.fehler(err.response?.data?.error || 'Fehler');
    } finally { setAbschlussSaving(false); }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '2rem' }}><div className="loading-spinner" style={{ margin: '0 auto' }} /></div>;
  if (error) return <div className="alert alert-error">{error}</div>;
  if (!gruppe) return null;

  const info = KURS_INFO[gruppe.kurs_typ] || { label: gruppe.kurs_typ, farbe: '#333', bg: '#f0f4f8', emoji: '🏊' };
  const auslastung = Math.round((gruppe.mitglieder.length / gruppe.max_teilnehmer) * 100);

  return (
    <div>
      {/* Header */}
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <button className="btn btn-secondary btn-sm" onClick={() => navigate('/gruppen')}>←</button>
          <span style={{ fontSize: '1.5rem' }}>{info.emoji}</span>
          <h2 className="page-title" style={{ margin: 0 }}>{gruppe.name}</h2>
          <span style={{ padding: '2px 10px', borderRadius: 10, fontSize: '0.78rem', fontWeight: 700,
            background: info.bg, color: info.farbe }}>{info.label}</span>
          {!gruppe.aktiv && <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: '0.72rem',
            background: '#f5f5f5', color: '#616161', fontWeight: 700 }}>Inaktiv</span>}
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button className="btn btn-secondary btn-sm" onClick={() => navigate(`/gruppen/${id}/bearbeiten`)}>✏ Bearbeiten</button>
          <button className="btn btn-primary btn-sm" onClick={openWlModal}>+ Aus Warteliste aufnehmen</button>
        </div>
      </div>

      {/* Gruppe-Infos */}
      <div className="card" style={{ padding: '1rem', marginBottom: '1.25rem' }}>
        <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', fontSize: '0.875rem' }}>
          {gruppe.trainer_name && <span>👤 <strong>{gruppe.trainer_name}</strong></span>}
          {gruppe.ort && <span>📍 <strong>{gruppe.ort}</strong></span>}
          {(gruppe.termine || []).map(t => (
            <span key={t.id}>📅 <strong>
              {WOCHENTAGE[t.wochentag]} {t.uhrzeit_von?.slice(0,5)}{t.uhrzeit_bis ? `–${t.uhrzeit_bis.slice(0,5)}` : ''}
            </strong></span>
          ))}
          <span style={{ marginLeft: 'auto' }}>
            <strong>{gruppe.mitglieder.length}</strong> / {gruppe.max_teilnehmer} Plätze
            <span style={{ display: 'inline-block', width: 80, height: 6, background: '#e0e0e0', borderRadius: 3, marginLeft: 8, verticalAlign: 'middle' }}>
              <span style={{ display: 'block', width: `${Math.min(auslastung, 100)}%`, height: '100%', borderRadius: 3,
                background: auslastung >= 100 ? '#c62828' : auslastung >= 80 ? '#f57c00' : info.farbe }} />
            </span>
          </span>
        </div>
        {gruppe.bemerkung && <div style={{ marginTop: '0.5rem', fontSize: '0.8rem', color: 'var(--text-muted)' }}>{gruppe.bemerkung}</div>}
      </div>

      {/* Mitgliederliste */}
      <div className="card">
        <div style={{ padding: '0.875rem 1rem', borderBottom: '1px solid var(--border)', fontWeight: 700, fontSize: '0.95rem' }}>
          Aktuelle Mitglieder ({gruppe.mitglieder.length})
        </div>

        {gruppe.mitglieder.length === 0 ? (
          <div className="empty-state" style={{ padding: '2rem' }}>
            <div className="empty-state-icon">🏊</div>
            <div className="empty-state-text">Noch keine Mitglieder in dieser Gruppe</div>
            <button className="btn btn-primary btn-sm" style={{ marginTop: '1rem' }} onClick={openWlModal}>
              Aus Warteliste aufnehmen
            </button>
          </div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Alter</th>
                  <th>Kontakt</th>
                  <th>In Gruppe seit</th>
                  <th>Gesundheit</th>
                  <th style={{ width: 140 }}></th>
                </tr>
              </thead>
              <tbody>
                {gruppe.mitglieder.map(m => (
                  <tr key={m.schwimmer_id}>
                    <td>
                      <div style={{ fontWeight: 600 }}
                        onClick={() => navigate(`/schwimmer/${m.schwimmer_id}`)}
                        className="link-text">
                        {m.vorname} {m.nachname}
                      </div>
                    </td>
                    <td>{calcAlter(m.geburtsdatum)}</td>
                    <td style={{ fontSize: '0.8rem' }}>
                      <div>{m.kontakt_name}</div>
                      <div className="td-muted">{m.kontakt_email}</div>
                    </td>
                    <td>{fmtDate(m.eingetreten_am)}</td>
                    <td style={{ fontSize: '0.78rem', color: m.gesundheitliche_hinweise ? '#c62828' : 'var(--text-muted)' }}>
                      {m.gesundheitliche_hinweise || '–'}
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '0.375rem' }}>
                        <button className="btn btn-secondary btn-sm"
                          onClick={() => navigate(`/schwimmer/${m.schwimmer_id}`)}>
                          Profil
                        </button>
                        <button className="btn btn-primary btn-sm"
                          onClick={() => openAbschluss(m)}
                          title="Abzeichen erteilt – Gruppe wechseln oder Vereinsaustritt">
                          🎓 Abschluss
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ── Trainingstermine ───────────────────────────────────────────── */}
      <div className="card" style={{ marginTop: '1.25rem' }}>
        <div style={{ padding: '0.875rem 1rem', borderBottom: '1px solid var(--border)', fontWeight: 700, fontSize: '0.95rem',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>📅 Trainingstermine</span>
          {(gruppe.termine || []).length > 0 && (
            <button className="btn btn-secondary btn-sm" style={{ fontWeight: 400, fontSize: '0.8rem' }}
              onClick={handleIcsExport} disabled={icsLoading}>
              {icsLoading ? 'Exportiere…' : '📅 Als Kalender (.ics)'}
            </button>
          )}
        </div>
        <div style={{ padding: '1rem' }}>
          {(gruppe.termine || []).length === 0 && (
            <div style={{
              background: '#fff8e1', color: '#e65100', border: '1px solid #ffe082',
              borderRadius: 8, padding: '0.6rem 0.8rem', fontSize: '0.85rem', marginBottom: '0.75rem',
            }}>
              <strong>Noch keine Trainingszeit hinterlegt.</strong> Ohne sie können Trainer für diese Gruppe
              kein Training starten und es lassen sich keine Trainer- oder Helferstunden buchen.
              Unten eintragen – Wochentag und Uhrzeit genügen.
            </div>
          )}
          {(gruppe.termine || []).map(t => (
            <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem',
              padding: '0.4rem 0', borderBottom: '1px solid #f0f0f0' }}>
              <span style={{ fontWeight: 600, minWidth: 100 }}>{WOCHENTAGE[t.wochentag]}</span>
              <span>{t.uhrzeit_von?.slice(0,5)}{t.uhrzeit_bis ? ` – ${t.uhrzeit_bis.slice(0,5)}` : ''} Uhr</span>
              <button className="btn btn-secondary btn-sm" style={{ marginLeft: 'auto', fontSize: '0.75rem' }}
                onClick={() => handleTerminDelete(t.id)}>✕</button>
            </div>
          ))}

          <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.75rem', flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div>
              <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: 2 }}>Wochentag</div>
              <select className="form-select" style={{ minWidth: 130 }}
                value={terminWochentag} onChange={e => setTerminWochentag(e.target.value)}>
                {WOCHENTAGE.map((w, i) => <option key={i} value={i}>{w}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: 2 }}>Von</div>
              <input type="time" className="form-input" style={{ width: 110 }}
                value={terminVon} onChange={e => setTerminVon(e.target.value)} />
            </div>
            <div>
              <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: 2 }}>Bis</div>
              <input type="time" className="form-input" style={{ width: 110 }}
                value={terminBis} onChange={e => setTerminBis(e.target.value)} />
            </div>
            <button className="btn btn-primary btn-sm" onClick={handleTerminAdd} disabled={terminSaving}>
              {terminSaving ? '…' : '+ Termin hinzufügen'}
            </button>
          </div>
        </div>
      </div>

      {/* ── Prüfungsfortschritt ───────────────────────────────────────── */}
      <div className="card" style={{ marginTop: '1.25rem' }}>
        <div
          style={{ padding: '0.875rem 1rem', borderBottom: fortschrittOpen ? '1px solid var(--border)' : 'none',
            fontWeight: 700, fontSize: '0.95rem', display: 'flex', alignItems: 'center',
            justifyContent: 'space-between', cursor: 'pointer' }}
          onClick={toggleFortschritt}
        >
          <span>📋 Prüfungsfortschritt</span>
          <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)', fontWeight: 400 }}>
            {fortschrittOpen ? '▲ Einklappen' : '▼ Anzeigen'}
          </span>
        </div>

        {fortschrittOpen && (
          <div style={{ padding: '1rem' }}>
            {fortschrittLoading && (
              <div style={{ textAlign: 'center', padding: '1rem' }}>
                <div className="loading-spinner" style={{ margin: '0 auto' }} />
              </div>
            )}
            {!fortschrittLoading && fortschritt && (
              fortschritt.uebungen.length === 0 ? (
                <div style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                  Keine Übungen für diesen Kurstyp definiert. Bitte unter Prüfungsanforderungen anlegen.
                </div>
              ) : fortschritt.mitglieder.length === 0 ? (
                <div style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Keine Mitglieder in dieser Gruppe.</div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ borderCollapse: 'collapse', fontSize: '0.78rem', minWidth: '100%' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left', padding: '0.4rem 0.5rem', background: '#f5f5f5',
                          borderBottom: '2px solid #ddd', position: 'sticky', left: 0, zIndex: 1, minWidth: 140 }}>
                          Schwimmer
                        </th>
                        {fortschritt.uebungen.map(u => (
                          <th key={u.id}
                            style={{ padding: '0.4rem 0.5rem', background: '#f5f5f5',
                              borderBottom: '2px solid #ddd', fontWeight: 600, textAlign: 'center',
                              minWidth: 90, maxWidth: 120, whiteSpace: 'normal', lineHeight: 1.3 }}
                            title={u.titel}>
                            {u.titel}
                          </th>
                        ))}
                        <th style={{ padding: '0.4rem 0.5rem', background: '#f5f5f5',
                          borderBottom: '2px solid #ddd', textAlign: 'center', minWidth: 60 }}>
                          Gesamt
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {fortschritt.mitglieder.map((m, mi) => {
                        const done = Object.keys(m.abgeschlossen).length;
                        const total = fortschritt.uebungen.length;
                        return (
                          <tr key={m.schwimmer_id} style={{ background: mi % 2 === 0 ? '#fff' : '#fafafa' }}>
                            <td style={{ padding: '0.4rem 0.5rem', fontWeight: 600, position: 'sticky', left: 0,
                              background: mi % 2 === 0 ? '#fff' : '#fafafa', borderBottom: '1px solid #eee',
                              cursor: 'pointer', color: 'var(--primary)' }}
                              onClick={() => navigate(`/schwimmer/${m.schwimmer_id}`)}>
                              {m.vorname} {m.nachname}
                            </td>
                            {fortschritt.uebungen.map(u => (
                              <td key={u.id}
                                style={{ textAlign: 'center', padding: '0.4rem 0.25rem',
                                  borderBottom: '1px solid #eee' }}
                                title={m.abgeschlossen[u.id]
                                  ? new Date(m.abgeschlossen[u.id]).toLocaleDateString('de-DE')
                                  : 'Noch nicht absolviert'}>
                                {m.abgeschlossen[u.id]
                                  ? <span style={{ color: '#2e7d32', fontSize: '1rem' }}>✓</span>
                                  : <span style={{ color: '#bbb', fontSize: '0.9rem' }}>○</span>}
                              </td>
                            ))}
                            <td style={{ textAlign: 'center', padding: '0.4rem 0.5rem',
                              borderBottom: '1px solid #eee', fontWeight: 700,
                              color: done === total ? '#2e7d32' : done > 0 ? '#e65100' : '#999' }}>
                              {done}/{total}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )
            )}
          </div>
        )}
      </div>

      {/* ── Warteliste-Aufnahme-Modal ──────────────────────────────────── */}
      {wlModal && (
        <Modal title={`Aus Warteliste aufnehmen → ${gruppe.name}`} onClose={() => setWlModal(false)} size="lg">
          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: '0.5rem' }}>
            Die Daten des Kindes werden in die Schwimmerdatenbank übernommen (inkl. Anmeldedatum,
            Antwort auf das Platzangebot und Aufnahmeantrag); der Wartelisten-Eintrag wird danach entfernt.
            Ohne Aufnahmeantrag ist nur eine vorläufige Aufnahme möglich.
          </p>
          {/* Belegung vor der Auswahl sichtbar, nicht erst beim Speichern */}
          {gruppe.max_teilnehmer > 0 && (
            <p style={{
              fontSize: '0.85rem', marginBottom: '1rem', fontWeight: 600,
              color: gruppe.mitglieder.length >= gruppe.max_teilnehmer ? '#c62828' : 'var(--text-muted)',
            }}>
              {gruppe.mitglieder.length >= gruppe.max_teilnehmer ? '⚠ ' : ''}
              {gruppe.name}: {gruppe.mitglieder.length} von {gruppe.max_teilnehmer} Plätzen belegt
              {gruppe.mitglieder.length > gruppe.max_teilnehmer
                ? ' – bereits überbucht'
                : gruppe.mitglieder.length === gruppe.max_teilnehmer ? ' – voll' : ''}
            </p>
          )}

          <div className="form-group">
            <label className="form-label">Eintrittsdatum</label>
            <input type="date" className="form-input" style={{ maxWidth: 200 }}
              value={aufnahmedatum} onChange={e => setAufnahmedatum(e.target.value)} />
          </div>

          {!wlLoading && warteliste.length > 0 && (
            <div className="form-group">
              <label className="form-label">Suchen</label>
              <input type="search" className="form-input" value={wlSuche} autoFocus
                onChange={e => setWlSuche(e.target.value)}
                placeholder="Name des Kindes, Name des Kontakts oder E-Mail" />
              <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: 4 }}>
                {wlWoerter.length
                  ? `${wlTreffer.length} von ${warteliste.length} Einträgen`
                  : `${warteliste.length} Einträge in Wartelisten-Reihenfolge`}
              </div>
            </div>
          )}

          {wlLoading ? (
            <div style={{ textAlign: 'center', padding: '1rem' }}><div className="loading-spinner" style={{ margin: '0 auto' }} /></div>
          ) : warteliste.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '1.5rem', color: 'var(--text-muted)' }}>
              Keine Wartelisten-Einträge für <strong>{info.label}</strong> vorhanden
            </div>
          ) : wlTreffer.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '1.5rem', color: 'var(--text-muted)' }}>
              Kein Eintrag passt zu „{wlSuche.trim()}"
            </div>
          ) : (
            <div className="table-wrap" style={{ maxHeight: 360, overflow: 'auto' }}>
              <table>
                <thead>
                  <tr><th></th><th>Kind</th><th>Alter</th><th>Wartezeit</th><th>Aufnahmeantrag</th><th>Kontakt</th></tr>
                </thead>
                <tbody>
                  {wlTreffer.map(w => (
                    <tr key={w.id} style={{ cursor: 'pointer', background: aufnehmen?.id === w.id ? '#e3f2fd' : undefined }}
                      onClick={() => setAufnehmen(aufnehmen?.id === w.id ? null : w)}>
                      <td>
                        <input type="radio" readOnly checked={aufnehmen?.id === w.id} />
                      </td>
                      <td>
                        <div style={{ fontWeight: 500 }}>{w.schwimmer_vorname} {w.schwimmer_nachname}</div>
                        {w.gesundheitliche_hinweise && (
                          <div style={{ fontSize: '0.72rem', color: '#c62828' }}>⚠ {w.gesundheitliche_hinweise}</div>
                        )}
                      </td>
                      <td>{calcAlter(w.schwimmer_geburtsdatum)}</td>
                      <td style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                        seit {fmtDate(w.anmeldedatum || w.created_at)}
                        {w.manuell_veraendert && <span style={{ marginLeft: 4, color: '#e65100' }}>✋</span>}
                        {w.platzangebot_zustand === 'angenommen' && (
                          <div style={{ color: '#2e7d32', fontWeight: 600 }}>Platzangebot angenommen</div>
                        )}
                      </td>
                      <td style={{ fontSize: '0.78rem' }}>
                        {w.aufnahmeantrag_eingang_am
                          ? <span style={{ color: '#2e7d32', fontWeight: 600 }}>✓ eingegangen {fmtDate(w.aufnahmeantrag_eingang_am)}</span>
                          : <span style={{ color: '#e65100' }}>fehlt → vorläufig</span>}
                      </td>
                      <td style={{ fontSize: '0.8rem' }}>
                        <div>{w.kontakt_vorname} {w.kontakt_nachname}</div>
                        <div className="td-muted">{w.kontakt_email}</div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {wlAuswahlVersteckt && (
            <div style={{ fontSize: '0.8rem', color: '#e65100', marginTop: '0.5rem' }}>
              Ausgewählt ist <strong>{aufnehmen.schwimmer_vorname} {aufnehmen.schwimmer_nachname}</strong> –
              der Eintrag ist durch die Suche gerade ausgeblendet.
            </div>
          )}

          <div className="modal-actions">
            <button className="btn btn-secondary btn-sm" onClick={() => setWlModal(false)}>Abbrechen</button>
            <button className="btn btn-primary btn-sm"
              onClick={handleAufnehmen}
              disabled={!aufnehmen || aufnehmenSaving}>
              {aufnehmenSaving ? 'Wird aufgenommen…'
                : aufnehmen ? `${aufnehmen.schwimmer_vorname} ${aufnehmen.schwimmer_nachname} aufnehmen`
                : 'Kind aus Liste wählen'}
            </button>
          </div>
        </Modal>
      )}

      {/* ── Abschluss-Modal ────────────────────────────────────────────── */}
      {abschlussModal && (
        <Modal title={`Abschluss: ${abschlussModal.vorname} ${abschlussModal.nachname}`}
          onClose={() => setAbschlussModal(null)} size="md">

          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: '1rem' }}>
            Das Kind hat die <strong>{info.label}</strong>-Ausbildung abgeschlossen.
            Das Abzeichen wird erteilt und der Eintrag in dieser Gruppe geschlossen.
          </p>

          <div className="form-group">
            <label className="form-label">Abzeichendatum</label>
            <input type="date" className="form-input" style={{ maxWidth: 200 }}
              value={abzeichenDatum} onChange={e => setAbzeichenDatum(e.target.value)} />
          </div>

          <div className="form-group">
            <label className="form-label">Was passiert als nächstes?</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '0.25rem' }}>
              {info.naechster && (
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                  <input type="radio" value="wechseln" checked={abschlussAktion === 'wechseln'}
                    onChange={() => setAbschlussAktion('wechseln')} />
                  <span>In nächste Gruppe ({KURS_INFO[info.naechster]?.label}) wechseln</span>
                </label>
              )}
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                <input type="radio" value="austritt" checked={abschlussAktion === 'austritt'}
                  onChange={() => setAbschlussAktion('austritt')} />
                <span>Kind verlässt den Verein</span>
              </label>
            </div>
          </div>

          {abschlussAktion === 'wechseln' && (
            <div className="form-group">
              <label className="form-label required">Zielgruppe ({KURS_INFO[info.naechster]?.label})</label>
              {naechsteGruppen.length === 0 ? (
                <div style={{ color: '#c62828', fontSize: '0.85rem', padding: '0.5rem', background: '#fff3e0', borderRadius: 6 }}>
                  ⚠ Keine aktiven {KURS_INFO[info.naechster]?.label}-Gruppen vorhanden. Bitte zuerst eine Gruppe anlegen.
                </div>
              ) : (
                <select className="form-select" value={naechsteGruppeId}
                  onChange={e => setNaechsteGruppeId(e.target.value)}>
                  <option value="">– Gruppe auswählen –</option>
                  {naechsteGruppen.map(g => (
                    <option key={g.id} value={g.id}>
                      {g.name} ({g.aktive_mitglieder}/{g.max_teilnehmer} Plätze)
                      {g.max_teilnehmer && g.aktive_mitglieder >= g.max_teilnehmer ? ' – voll' : ''}
                    </option>
                  ))}
                </select>
              )}
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Bemerkung <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>(optional)</span></label>
            <textarea className="form-control" rows={2} value={abschlussBemerkung}
              onChange={e => setAbschlussBemerkung(e.target.value)}
              placeholder="Notiz zum Abschluss…" />
          </div>

          <div className="modal-actions">
            <button className="btn btn-secondary btn-sm" onClick={() => setAbschlussModal(null)}>Abbrechen</button>
            <button className="btn btn-primary btn-sm" onClick={handleAbschluss}
              disabled={abschlussSaving || (abschlussAktion === 'wechseln' && !naechsteGruppeId)}>
              {abschlussSaving ? 'Wird gespeichert…' : '🎓 Abschluss bestätigen'}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}
